import { useQuery } from '@tanstack/react-query';

type AdminCalendar = {
  id: string;
  externalId: string | null;
  platform: 'MICROSOFT' | 'GOOGLE' | 'AFTERNOON';
  status: 'CONNECTING' | 'CONNECTED' | 'DISCONNECTED';
  emailAddress: string | null;
  userId: string;
  createdAt: string;
  eventFirstSyncedAt: string | null;
  isDeleted: boolean;
};

export type { AdminCalendar };

export const useAdminCalendars = (companyId: string) => {
  const { data, isLoading, isError, refetch, isRefetching } = useQuery<AdminCalendar[]>({
    queryKey: ['admin', 'companies', companyId, 'calendars', 'health'],
  });

  return { calendars: data, isLoading, isError, refetch, isRefetching };
};
